function prepareCookieValues({key, value, time}) {
  const values = {[key]: value || '', path: '/'};
  if (time) {
    const date = new Date();
    date.setTime(date.getTime() + time);
    values.expires = date.toUTCString();
  }
  return values;
}

export function setCookie(key, value, time = 0) {
  const valueObj = prepareCookieValues({key, value, time});
  const valueArr = Object.keys(valueObj).map(field => `${field}=${valueObj[field]}`);
  valueArr.push('SameSite=None', 'Secure');
  document.cookie = valueArr.join('; ');
}

export function getCookie(key) {
  const nameEQ = key + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function deleteCookie(key) {
  document.cookie = key + '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 UTC;';
}
